<p-table [value]="listPayments" styleClass="p-datatable" id="table_commissions">
  <ng-template pTemplate="header">
    <tr>
      <th>Marca</th>
      <th>Comisión</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-products>
    <tr>
      <td>
        <div class="datatable__info">
          <i class="pi pi-mobile"></i>
          <div class="datatable__infoText">
            <p>{{products.marca}}</p>
            <span>{{products.fecha | date: 'MMMM d, yyyy' | titlecase}}</span>
          </div>
        </div>
      </td>
      <td>
        <div class="datatable__value">
          <p>{{products.comision | currency}}</p>
        </div>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="summary">
    <div class="generalButton flex">
      <button pButton pRipple label="Ver más comisiones" icon="pi pi-eye" iconPos="left" class="p-button-secondary p-button-raised p-button-rounded n-background min-pad"  [routerLink]="['/comisiones/por-marca']"></button> 
    </div>
  </ng-template>
</p-table>
